let _this = {


    /*-------------------------------------------------------------------------------
        # Cache dom and strings
    -------------------------------------------------------------------------------*/
    $dom: {
        mainNavigation: $('.main-navigation'),
    },

    vars: {
        startPoint: 0
    },

    /*-------------------------------------------------------------------------------
        # Initialize
    -------------------------------------------------------------------------------*/
    init: function () {

        let screenWidth = $(window).width();
        if (screenWidth > 991) {
            $(window).on('scroll load', function () {
                if ($(window).scrollTop() > _this.vars.startPoint) {
                    _this.$dom.mainNavigation.addClass('sticky-header');
                } else if ($(window).scrollTop() < _this.vars.startPoint) {
                    _this.$dom.mainNavigation.removeClass('sticky-header');
                }
            });
        }
    }
}

export default _this;